import React,{useEffect} from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAppContext } from "./../AppContext"
import DashboardTabs from "./DashboardTabs.js";
import PatientDashboardTabs from "./patient/DashboardTabs.js";
function AppHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser,user, isAuthenticated,isDoctor,isPatient,role, setIsAuthenticated,setState,setRole,state } = useAppContext();
  const [showDashboardTabs, setShowDashboardTabs] = React.useState(false);
  const [showPatientDashboardTabs, setShowPatientDashboardTabs] = React.useState(false);

  useEffect(() => {
    ///console.log("User role in AppHeader:", user?.role);

    const isDoctorRole = user?.role?.toLowerCase() === "doctor";
    const isPatientRole = user?.role?.toLowerCase() === "patient";

    setShowDashboardTabs(isDoctorRole);
    setShowPatientDashboardTabs(isPatientRole);
    ///console.log("isDoctorRole:", isDoctorRole);
    ///console.log("isPatientRole:", isPatientRole);
    
  }, [user]);

  useEffect(() => {
    console.log("User role in isAuthenticated:", isAuthenticated);
    //setShowDashboardTabs(isAuthenticated);

    if (isAuthenticated) {
//console.log("User role in AppHeader:", user?.role);

    console.log("state", state);
    let isDoctorRole = false;
    let isPatientRole = false;

    if(state?.patientId && state?.patientInfo) {
      isPatientRole = true;
    } else if(state?.doctorInfo) {
      isDoctorRole = true;
    }

    setShowDashboardTabs(isDoctorRole);
    setShowPatientDashboardTabs(isPatientRole);
    //console.log("isDoctorRole:", isDoctorRole);
    //console.log("isPatientRole:", isPatientRole);
    }

  }, [isAuthenticated]);

  const isRootPath = location.pathname === "/";

  const handleLogout = () => {   
    setUser(null);
    setRole('');
    setIsAuthenticated(false);
    setState({
      idToken: null,
      accessToken: null,
      email: null,
      patientId: null,
      awsCreds: null,
      user: null,
      patientInfo: null,
      doctorInfo: null
    });
    navigate("/app");
  };

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container">
        <div className="navbar-brand" >
         CareLoop™  <span style={{fontSize:'12px'}} >| An AI-powered digital front door for healthcare</span>
        </div>
        {
          !isRootPath && <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#menu"
            aria-controls="menu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        }

        {
          !isRootPath && <div className="collapse navbar-collapse" id="menu">
            <ul className="navbar-nav ms-auto align-items-lg-center">

              {/* { isAuthenticated && 
              <li className="nav-item">
                <Link to="/doctor-dashboard" className="book-btn">
                  Dashboard
                </Link>
              </li>} */}

              {!isAuthenticated &&
                <li className="nav-item" >
                  {/* <a className="nav-link" href="#home">
                  Home
                </a> */}
                  <Link to="/app" className="nav-link">
                    Home
                  </Link>

                </li>}
              {!isAuthenticated &&
                <li className="nav-item">
                  <Link to="/about" className="nav-link">
                    About
                  </Link>
                  {/* <a className="nav-link" href="#about">
                  About
                </a> */}
                </li>}
              {!isAuthenticated &&
                <li className="nav-item">
                  {/* <a className="nav-link" href="#services">
                  Services
                </a> */}
                  <Link to="/ourservices" className="nav-link">
                    Services
                  </Link>
                </li>}
              {!isAuthenticated &&
                <li className="nav-item">
                  {/* <a className="nav-link" href="#contact">
                  Contact
                </a> */}
                  <Link to="/contact" className="nav-link">
                    Contact
                  </Link>
                </li>}
              {/* { isAuthenticated && 
              <li className="nav-item">
                <Link to="/doctor-vedio" className="book-btn">
                  Vedio Invite
                </Link>
              </li>} */}

              {!isAuthenticated && <li className="ms-lg-4 mt-3 mt-lg-0">
                <Link to="/doctor-login" className="book-btn">
                  Book Appointment
                </Link>
              </li>}
             
              {!isAuthenticated &&
                <li className="ms-lg-4 mt-3 mt-lg-0">
                  {/* <a href="/lander" className="book-btn" >
                  Login
                </a> */}
                  <Link to="/doctor-login" className="book-btn">
                    Login
                  </Link>
                </li>
              }

              {isAuthenticated && showDashboardTabs &&
              
                <DashboardTabs style={{ paddingTop: '1rem' }} name={'conference'} />
              }
              {isAuthenticated && showPatientDashboardTabs &&
                <PatientDashboardTabs style={{ paddingTop: '1rem' }} name={''} />
              }

              {/* {
                <li className="ms-lg-4 mt-3 mt-lg-0"> {isAuthenticated && user?.role}</li>
              } */}

              {isAuthenticated &&
                <li className="ms-lg-4 mt-3 mt-lg-0">
                  <button onClick={() => { handleLogout() }} className="btn  btn-link " style={{ backgroundColor: 'transparent', color: '#0f4c81', textDecoration: 'none', border: 'none', padding: '0', cursor: 'pointer' }}>
                    Logout
                  </button>
                </li>
              }

            </ul>
          </div>

        }


      </div>
    </nav>
  );
}

export default AppHeader;
